import React, { useState, useEffect } from "react"
import Modal from "../../../../global/components/modal"
import useRetrieveData from "../../../../global/hooks/useRetrieveData"
import { get, size } from "../../../../global/lib/lodash"
import { Text } from "../../../../global/components/text"
import { Row } from "../../../../global/components/row"
import { Icon } from "@mui/material"
import { useStyles } from "./styles"
import ScoreIcon from "../../../../global/components/ScoreIcon"
import Confirm from "../../../../global/components/confirm"
import { CenterLoader } from "../../../../global/styles"
import sendData from "../../../../redux/actions/sendData"
import NoData from "../../../../global/components/NoData"
import Switch from "../../../../global/components/switch"

const useTargetScoresFromScorecard = props => {
    const scnum = get(props, 'scorecardId', null);
    const aid = get(props, 'assessment.data.id');
    const [page, setPage] = useState({
        size: 100,
        number: 1,
    })

    const url = props.template ? `/assessment-templates` : '/assessments';

    const targetscores = useRetrieveData({ url }, {
        waitFor: scnum,
        build: ['assessments'],
        useEffects: true,
        params: {
            include: 'realm,realm.parent',
            filter: {
                forecast_clone_scorecard_context: scnum,
                realm: props.useLocation ? `${get(props, 'assessment.data.realmId')}` : undefined,
            },
            page
        }
    }, [props.useLocation]);

    return {
        ...targetscores,
        data: targetscores.data.filter(f => f.id != aid),
    }
}

const ScoreRow = props => {
    const scnum = Object.keys(props.forecastScores)[0];// get(props, 'scorecardId', null);
    const { displayValue, calculatedScore } = get(props, `forecastScores.${scnum}`, {});
    const rname = ['realm.parent.name', 'realm.name'].map(k => get(props, k)).filter(f => !!f).join(' - ');

    return (
        <Row className={'row'} onClick={e => props.onClick(props, e)}>
            <div className="icon"><Icon>add</Icon></div>
            <div className="title">
                <Text type="label_medium" bold>{get(props, 'name', '')}</Text>
                <Text type="label_medium" bold italic>{`for ${rname}`}</Text>
            </div>
            <Row className="score">
                <Text type="label_medium" bold>{`TARGET: ${displayValue || ''}`}</Text>
                <ScoreIcon score={calculatedScore} />
            </Row>
        </Row>
    )
}

const ScoreCopy = props => {
    const classes = useStyles();
    const [state, setState] = useState({
        useLocation: true,
    })
    
    const scores = useTargetScoresFromScorecard({ ...props, ...state });
    const tempscores = useTargetScoresFromScorecard({ ...props, template: true, ...state });
    
    const [confirm, setConfirm] = useState({});

    const selectRow = r => {
        const aid = get(props, 'assessment.data.id');

        setConfirm({
            title: 'Are you sure?',
            content: <div>You are creating Target scores for this Assessment from <b>{r.name}</b>. Would you like to continue?</div>,
            onOk: async () => {
                try {
                    await sendData({
                        url: `/assessments/${aid}/target-scores`,
                        method: 'PATCH',
                        data: {
                            data: {
                                type: "assessments",
                                id: aid,
                                attributes: {
                                    target_origin_id: r.id,
                                }
                            }
                        }
                    })
    
                    setConfirm({});
                    props.updateScoresAfterCopy();
                    props.onClose();
                } catch (err) {
                    alert(err.toString());
                }
            },
            onCancel: () => {
                setConfirm({});
            }
        })
    }

    const isShowingNone = !scores.loading && !tempscores.loading && !size(scores.data) && !size(tempscores.data);

    useEffect(() => {
        props.isShowingNone && props.isShowingNone(isShowingNone);
    }, [isShowingNone]);

    return (
        <div>
            <Text>Add target scores to this assessment from the targets made in previous assessments.</Text>
            
            <div>
                <Row>
                    <Text>Use Location</Text>
                    <Switch checked={state.useLocation} onChange={() => setState(s => ({ ...s, useLocation: !s.useLocation }))} />
                </Row>
            </div>
            
            <div style={{ width: '100%', height: 10 }} />

            {!isShowingNone && <div>
                <Text type="title_medium" bold>Use a Template</Text>
                <div className={classes.listContainer}>
                    {tempscores.data.map((r, i) => <ScoreRow key={r.id} {...props} {...r} onClick={selectRow} />)}
                    {tempscores.loading && <CenterLoader />}
                </div>

                <div style={{ width: '100%', height: 50 }} />

                <Text type="title_medium" bold>Use a Previous Assessment</Text>
                <div className={classes.listContainer}>
                    {scores.data.map((r, i) => <ScoreRow key={r.id} {...props} {...r} onClick={selectRow} />)}
                    {scores.loading && <CenterLoader />}
                </div>
            </div>}

            {isShowingNone && 
                <NoData 
                    secondaryText="Target scores are copied from previously created targets; “Add New Target Scores” on a previous assessment or template to copy them here." 
                    noDataText="No Target Scores to Copy"
                    showButtons={state.useLocation}
                    buttons={[{ text: 'show more', onClick: () => setState(s => ({ ...s, useLocation: false })) }]}
            />}
            <Confirm {...confirm} />
        </div>
    )
}


export const ScoreCopyModal = props => {
    const open = !!props.open;
    
    return (
        <Modal {...props} open={!!open}>
            {open && <ScoreCopy {...props} />}
        </Modal>
    )
}